export const handleErrorResponse = (error: unknown) =>
  error ? (error as { message: string })?.message : error
